export default {
  googleAnalyticsId: null,
  modulo: "Seguro de hogar",
  cantPasos: 4,
  isMobile: false,
  pasos: {
    paso1: {
      path: "/",
      paso: 1,
      component: "views/common/Paso1",
      titulo: "Cotizá tu seguro de hogar 100% online",
      subtitulo:
        "Te pedimos este dato para saber si sos cliente y poder cotizar un seguro adecuado para vos.",
      imgdeco: require("@/assets/img/WomanSofa.png"),
      imgdecoMobile: require("@/assets/img/hogar/SeguroHogar.png"),
      pasoSiguiente: "paso2"
    },
    paso2: {
      path: "/paso2",
      paso: 2,
      component: "views/hogar/Paso1Hogar",
      titulo: "Cotizá tu seguro de hogar",
      subtitulo: "Ingresá los datos de tu casa y calculá tu cuota mensual.",
      titulo_modalRequisitos: "Requisitos mínimos de seguridad",
      titulo_modalCondiciones:
        "Términos y condiciones sobre la promoción de bienvenida",
      footerSegurosText: "true",
      pasoSiguiente: "paso3"
    },
    paso3: {
      path: "/paso3",
      paso: 3,
      component: "views/hogar/Paso3Hogar",
      titulo1: "Cotizá tu seguro de hogar",
      subt1: "Conocé lo que incluye tu seguro de hogar: ",
      titulo2: "Coberturas fijas",
      subt2: "Estas son tus coberturas incluidas:",
      titulo3: "Coberturas personalizadas",
      subt3: "Podés editar los montos de las siguientes coberturas incluidas:",
      pasoSiguiente: "paso4",
      coberturasData: [
        {
          codigoCobertura: "110",
          imgSrc: "fuego.png",
          title: "Incendio de <br />inmueble",
          modalLabel: "Incendio de inmueble",
          modalBody: `<p>
          Esta cobertura cubre todos los daños materiales causados por acción
          directa o indirecta del fuego, tanto en la vivienda asegurada como en su
          baulera. Incluye los daños causados por explosión o rayos.
          <br />
          En el frente de póliza figura como Inc Edif 1ER Riesgo.F
          </p>`
        },
        {
          codigoCobertura: "114",
          imgSrc: "rodillo.png",
          title: "Daños <br />estéticos",
          modalLabel: "Daños estéticos",
          modalBody: `<p>
          Esta cobertura cubre la restauración de la estética de tu hogar, en caso de incendio.
          <br />
          En el frente de póliza figura como Daños Estéticos.
          </p>`
        },
        {
          codigoCobertura: "112",
          imgSrc: "limpieza.png",
          title: "Limpieza",
          modalLabel: "Limpieza",
          modalBody: `<p>Esta cobertura cubre los gastos de limpieza, retiro de escombros o demolición del inmueble o de las partes de los bienes asegurados destruidos, en caso de incendio o cualquier otro riesgo cubierto por esta póliza.
          <br />
          En el frente de póliza figura como Gs Limp/Escom/Demol.</p>`
        },
        {
          codigoCobertura: "115",
          imgSrc: "heladera.png",
          title: "Alimentos <br />refrigerados",
          modalLabel: "Alimentos refrigerados",
          modalBody: `<p>Esta cobertura cubre la reposición de los alimentos refrigerados en heladeras, freezer o aparatos congeladores de uso doméstico, en caso de cortes de luz de la red pública por más de 12 horas consecutivas.
          <br /><br />
          Solo cubre cuando la falta de suministro eléctrico sea originado por causas imputables directamente a la acción u omisión del ente proveedor de energía eléctrica.
          <br /><br />
          En el frente de póliza figura como Pérdida de alimen.</p>`
        },
        {
          codigoCobertura: "104",
          imgSrc: "alojamiento.png",
          title: "Alojamiento",
          modalLabel: "Alojamiento",
          modalBody: `<p>Esta cobertura cubre los gastos de alojamiento en concepto de hospedaje en hotel o el pago de alquiler de una vivienda similar a la asegurada, solo cuando el siniestro de incendio torne inhabitable el inmueble asegurado. 
          <br /><br />
          No incluye comidas, bebidas, refrigerios, lavandería, planchado, tintorería, telefonía, servicios, impuestos, expensas, alquiler de vivienda, ni otro gasto que exceda el costo de habilitación para quienes habitaban el inmueble asegurado.
          <br /><br />
          En el frente de póliza figura como Gs de Alojamiento.</p>`
        },
        {
          codigoCobertura: "113",
          imgSrc: "honorarios.png",
          title: "Honorarios de<br />profesionales",
          modalLabel: "Honorarios de profesionales",
          modalBody: `<p>Esta cobertura cubre los gastos de los honorarios profesionales incurridos en la reconstrucción del inmueble asegurado, debido a su destrucción o daño por cualquier riesgo asegurado bajo la cobertura de incendio.
          <br /><br />
          En el frente de póliza figura como Honorarios Profes.</p>`
        },
        {
          codigoCobertura: "102",
          imgSrc: "fuegosillon.png",
          title: "Incendio de <br />bienes",
          modalLabel: "Incendio de bienes",
          modalBody: `<p>Esta cobertura cubre los bienes materiales (que se encuentren en el domicilio asegurado) que se hayan dañado por acción directa o indirecta del fuego y los que se extravíen durante el siniestro.
          <br /><br />Se entiende por fuego, toda combustión que origine incendio o principio de incendio. Incluye los daños causados por explosión o rayos.
          <br /><br />Se limita hasta el 10% de la suma asegurada la cobertura de los siguientes bienes (salvo que constituyan una colección, en ese caso la limitación se aplica a ese conjunto): medallas, alhajas, cuadros, plata labrada, estatuas, armas, encajes, cachemires, tapices, cosas raras y preciosas, movibles o fijas y cualquier otro objeto artístico, científico o de colección de valor excepcional por su antigüedad o procedencia. 
          <br /><br />Quedan excluidos del seguro los bienes: moneda (papel o metálico), oro, plata y otros metales preciosos, perlas y piedras preciosas no engarzadas, manuscritos, documentos, papeles de comercio, títulos, acciones, bonos y otros valores mobiliarios, patrones, clisés, matrices, modelos y moldes, croquis, dibujos y planos técnicos, colecciones filatélicas, explosivos, animales, plantas, vehículos que requieran licencia para circular y los bienes asegurados con pólizas con coberturas que comprendan el riesgo de incendio.
          <br /><br />En el frente de la póliza figura como Incendio Contenido.
          </p>`
        },
        {
          codigoCobertura: "211",
          imgSrc: "lavarropa.png",
          title: "Electrodomésticos",
          modalLabel: "Electrodomésticos",
          modalBody: `<p>Esta cobertura cubre tus electrodomésticos en caso de robo o daño accidental o incendio. También cubre los daños o pérdidas por falta o deficiencia de energía eléctrica.
          <br /><br />Electrodomésticos cubiertos: tv, video, audio, dvd, pc de escritorio, impresora, microondas, videoconsola de juegos, horno/cocina eléctrica, termotanque eléctrico, lavarropa, lavavajilla, heladera, freezer, cava y equipo de aire acondicionado frío/calor.
          <br /><br />En el frente de póliza figura como Eq. Electromecánicos.
          </p>`
        },
        {
          codigoCobertura: "201",
          imgSrc: "ladron.png",
          title: "Robo de <br />pertenencias",
          modalLabel: "Robo de pertenencias",
          modalBody: `<p>Esta cobertura cubre la pérdida o daños de tus bienes por causa de robo y/o hurto o su tentativa. Incluye robo en baulera y los cometidos por el personal doméstico.
          <br /><br />En el frente de póliza figura como Robo/hurto contenido.
          </p>`
        },
        {
          codigoCobertura: "215",
          imgSrc: "dispositivos.png",
          title: "Tecnología <br />portátil",
          modalLabel: "Tecnología portátil",
          modalBody: `<p>Esta cobertura protege tus dispositivos portátiles dentro y fuera de tu hogar, por pérdida o daño causado por incendio, robo o accidente dentro del país.
          <br /><br />Dispositivos cubiertos: notebook/netbook/tablet, reproductor de audio y multimedia digital, dvd portátil, cámara de fotos, videocámaras y videoconsola portátil.
          <br /><br />En el frente de póliza figura como TR-EQ Portatil Mundo.
          </p>`
        },
        {
          codigoCobertura: "301",
          imgSrc: "vidrio.png",
          title: "Cristales",
          modalLabel: "Cristales",
          modalBody: `<p>Esta cobertura cubre la rotura o rajadura de cristales, vidrios, espejos y otras piezas vítreas o similares colocadas en posición vertical (siempre que estén instaladas correctamente). También, contempla los gastos de colocación.
          <br /><br />No incluye cristales instalados en hornos y cocinas.
          <br /><br />En el frente de póliza figura como Cristales.
          </p>`
        },
        {
          codigoCobertura: "301",
          imgSrc: "vidrio.png",
          title: "Cristales",
          modalLabel: "Cristales",
          modalBody: `<p>Esta cobertura protege tus dispositivos portátiles dentro y fuera de tu hogar, por pérdida o daño causado por incendio, robo o accidente dentro del país.
          <br /><br />Dispositivos cubiertos: notebook/netbook/tablet, reproductor de audio y multimedia digital, dvd portátil, cámara de fotos, videocámaras y videoconsola portátil.
          <br /><br />En el frente de póliza figura como TR-EQ Portatil Mundo.
          </p>`
        }
      ]
    },

    paso4: {
      path: "/paso4",
      paso: 4,
      component: "views/hogar/Paso4Hogar",
      titulo1: "Cotizá tu seguro de hogar",
      titulo2: "Coberturas adicionales",
      subt2:
        "Las coberturas adicionales son opcionales, por lo que podés agregar a tu plan las que más se adapten a tus necesidades. <br> <br>  Al continuar te pediremos tu dni, usuario y contraseña para elegir tu medio de pago y finalizar la contratación.",
      pasoSiguiente: "paso4",
      coberturasData: [
        {
          codigoCobertura: "501",
          imgSrc: "civil.png",
          title: "Responsabilidad civil ante terceros",
          modalLabel: "Responsabilidad civil ante terceros",
          modalBody: `<p>
          Es una cobertura que te protege económicamente a vos, tu cónyuge u otra persona (de la cual seas legalmente responsable) por daño accidental que puedan ocasionar a un tercero.  Mientras los hechos no estén vinculados a tu actividad profesional, comercial, laboral o industrial.
          <br />
          En el frente de póliza figura como Resp Civil Privada.
          </p>`
        },
        {
          codigoCobertura: "403",
          imgSrc: "accidentes.png",
          title: "Accidentes personales",
          modalLabel: "Accidentes personales",
          modalBody: `<p>Esta cobertura solo cubre al titular de la póliza en caso de sufrir invalidez parcial, permanente o total a causa de un accidente. El monto será acorde al tipo de invalidez. En caso de muerte, se indemnizará a la familia por la suma asegurada.
           <br />
           En el frente de la póliza figura como Accidentes Pers.</p>`
        },
        {
          codigoCobertura: "234",
          imgSrc: "robo-esp.png",
          title: "Robo de objetos específicos",
          modalLabel: "Robo de objetos específicos",
          modalBody: `<p>Esta cobertura cubre objetos específicos dentro del hogar, en caso de robo. La cobertura en este caso es a prorrata.
           <br /><br />
           En el frente de póliza figura como Robo Obj Específicos.
          <br /><br /></p>`
        },
        {
          codigoCobertura: "601",
          imgSrc: "inundacion.png",
          title: "Daños por agua e inundación",
          modalLabel: "Daños por agua e inundación",
          modalBody: `<p>Esta cobertura cubre los gastos de reparación de daños producidos por la acción directa del agua, filtraciones de cañerías internas del edificio e inundación por agua proveniente del exterior.
          <br /><br />
          En el frente de póliza figura como Daños por agua. 
          <br /><br /></p>`
        },
        {
          codigoCobertura: "502",
          imgSrc: "botiquin.png",
          title: "Personal doméstico",
          modalLabel: "Personal doméstico",
          modalBody: `<p>Responsabilidad civil para personal doméstico. Esta cobertura te protege ante accidentes del personal doméstico en el domicilio asegurado. No exime a la persona asegurada de sus obligaciones patronales.
           <br /><br />
           En el frente de póliza figura como Resp Civil Doméstico.</p>`
        },
        {
          codigoCobertura: "212",
          imgSrc: "robo-dinero.png",
          title: "Robo de dinero en efectivo",
          modalLabel: "Robo de dinero en efectivo",
          modalBody: `<p>Esta cobertura cubre la reposición del dinero en efectivo que haya en tu propiedad, en caso de robo.
          <br /><br />En el frente de póliza figura como Robo dinero efvo dom.
          </p>`
        },
        {
          codigoCobertura: "700",
          imgSrc: "mascotas.png",
          title: "Mascotas",
          modalLabel: "Mascotas",
          modalBody: `<p>Esta cobertura cubre los gastos veterinarios, gastos por muerte o sacrificio del animal doméstico que viva en la casa asegurada, en caso de accidente.
          <br /><br />El animal debe ser un perro o gato de pedigree con papeles que lo acrediten.
          <br /><br />En el frente de póliza figura como Mascotas.
          </p>`
        },
        {
          codigoCobertura: "103",
          imgSrc: "resp-civil.png",
          title: "Responsabilidad civil de linderos",
          modalLabel: "Responsabilidad civil de linderos",
          modalBody: `<p>Esta cobertura cubre los daños materiales ocasionados a tus vecinos y vecinas por la acción directa o indirecta del fuego en tu propiedad.
          <br /><br />En el frente de póliza figura como R.C. Linderos.
          </p>`
        },
        {
          codigoCobertura: "701",
          imgSrc: "golf.png",
          title: "Jugadores de golf",
          modalLabel: "Jugadores de golf",
          modalBody: `<p>Esta cobertura está dirigida a las personas que juegan golf y a sus equipos deportivos. Cubre el daño o la pérdida de los palos de golf de la persona asegurada dentro del país.
          <br /><br />Hoyo en uno: cubre los gastos documentados de acuerdo al reglamento de la Asociación Argentina de Golf.
          <br /><br />También cubre la responsabilidad civil de la persona asegurada en caso de accidente al jugar en cualquier cancha reconocida por la Asociación Argentina de Golf.
          </p>`
        }
      ]
    },

    mensaje: {
      path: "/mensaje/:mje",
      component: "views/common/Mensaje"
    },
    loading: {
      path: "/loading/:mje",
      component: "views/common/Verificacion"
    }
  }
};
